import React from 'react';
import DocumentoNoDisponible from './DocumentoNoDisponible';

const CompendioCap4 = () => (
  <DocumentoNoDisponible titulo="Compendio Estadístico 2017 - 2021 · Capítulo 4" />
);

export default CompendioCap4;
